import { QueryResult, QueryConfig } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Compra } from "@/shared/types/compra";

export async function getCompra(id: string): Promise<Compra> {
    await sleep(1000);
    const response = await api.get("compras/" + id);
    return response.data;
}

export function useGetCompraQuery(id: string, queryConfig: QueryConfig<Compra> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getCompra(id),
        queryKey: ["compras", id],
    })
}

export interface GetCompraQueryProps {
    id: string,
    queryConfig?: QueryConfig<Compra>,
    children?: (queryResult: QueryResult<Compra>) => ReactNode
}

export function GetCompraQuery({
    id,
    children,
    queryConfig
}: GetCompraQueryProps) {
    const queryResult = useGetCompraQuery(id, queryConfig);
    return children && children(queryResult);
}